import { z } from "zod";

export const imageSchema = z.object({
  url: z.string(),
  alt: z.string(),
  width: z.number(),
  height: z.number(),
  updatedAt: z.string().optional(),
});

export const buttonSchema = z.object({
  label: z.string(),
  url: z.string(),
});
